<img
    src="assets/images/logo.svg"
    alt="logo"
    height="60"
    routerLink="/"
    class="pointer"
/>
